import apiSvc from "../../services/api-service";
import { setAssets } from "./assets-action";

export async function loadAssetsList(dispatch: any) {
  apiSvc.get('SelectAssetsRequest').then((response) => dispatch(setAssets(response?.data.Data)));
}
